import { SEASON_SUB_PATH, SERIES_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { SeasonInterface } from 'type/seasonType';

class SeriesSeasonItemService {
  constructor(private readonly apiService: ApiService<SeasonInterface>) {}

  public async fetchChildItemsByParentId(
    seriesId: number,
    queryParams?: URLSearchParams
  ): Promise<SeasonInterface[]> {
    return await this.apiService.fetchChildItemsByParentId<SeasonInterface[]>(
      seriesId,
      SEASON_SUB_PATH,
      queryParams
    );
  }

  public async createItemsForParent(seriesId: number, ids: number[]): Promise<void> {
    return this.apiService.createItemsForParent(seriesId, SEASON_SUB_PATH, { ids }, undefined);
  }

  public async deleteItemsForParent(seriesId: number, itemIds: number[]): Promise<void> {
    const queryParams = new URLSearchParams();
    itemIds.forEach(id => queryParams.append('ids', id.toString()));
    return this.apiService.deleteItemsForParent(seriesId, SEASON_SUB_PATH, queryParams);
  }
}

export const seriesSeasonItemService = new SeriesSeasonItemService(new ApiService(SERIES_API_PATH));
